'use client'

import { gtag, isAnalyticsEnabled } from '@/utils/analytics/gtag'

import { useReportWebVitals } from 'next/web-vitals'

// Streams Web Vitals (CLS, LCP, INP, FCP, TTFB, FID) to GA4 as custom events
// using the canonical GA4 shape. Each metric becomes one event named after
// the metric (e.g. "LCP"), tagged with event_category="Web Vitals" so GA's
// built-in reports can surface them.
//
// CLS is multiplied by 1000 because GA4 stores `value` as an integer.

export function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    if (!isAnalyticsEnabled()) return

    const value = Math.round(
      metric.name === 'CLS' ? metric.value * 1000 : metric.value
    )

    gtag('event', metric.name, {
      value,
      event_category: 'Web Vitals',
      event_label: metric.id,
      metric_value: metric.value,
      metric_rating: metric.rating,
      metric_delta: metric.delta,
      non_interaction: true
    })
  })

  return null
}
